/** @format */

import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import {
  HomefieldIconsLibraryService,
  homefieldIconSignCancelOutline,
} from '@dsg-tech/homefield-angular-icons';

import { CompareBarProduct } from '@shared/data-access/interfaces';
import { HmfButtonComponent } from '@dsg-tech/homefield-angular';

@Component({
  selector: 'plp-components-compare-thumbnail',
  imports: [HmfButtonComponent],
  templateUrl: './compare-thumbnail.component.html',
  styleUrl: './compare-thumbnail.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompareThumbnailComponent {
  private readonly homefieldIconsLibraryService = inject(HomefieldIconsLibraryService);

  readonly compareData = input<CompareBarProduct | null>(null);

  readonly remove = output<{ ecode: string | undefined; trigger: 'keyboard' | 'mouse' }>();

  constructor() {
    this.homefieldIconsLibraryService.registerIcons([homefieldIconSignCancelOutline]);
  }

  onRemove(event: PointerEvent): void {
    const trigger = event.pointerType === '' ? 'keyboard' : 'mouse';
    this.remove.emit({ ecode: this.compareData()?.ecode, trigger });
  }
}
